import * as React from "react";

;
export const StarLoyalty = (props: React.SVGProps<SVGSVGElement>) => <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 .5l1.622 3.767 4.084.379-3.081 2.707.902 4.001L6 9.26l-3.527 2.094.902-4.001L.294 4.646l4.084-.379L6 .5z" fill="#100722" /></svg>;